/** 公共路由 */
export const commonRoutes = {
  /** 登录 */
  Login: '/login',
  /** 用户管理 */
  UserManage: '/manage/setting/user/list',
};
